var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D26\u6237\u4F59\u989D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD1FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-30.000000, -120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-67",
    transform: "translate(8.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-65",
    transform: "translate(22.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8D26\\u6237\\u4F59\\u989D",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.47825261,0 0,4.47827219 0,10 C0,15.5217474 4.47827219,20 10,20 C15.5217474,20 20,15.5217278 20,10 C20,4.47825261 15.5217278,0 10,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#5F8AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5072458,6.82608766 C14.8260861,6.82608766 15.0869569,6.94202987 15.3043485,7.15942034 C15.5217401,7.37681199 15.6376812,7.65217513 15.6376812,7.95652304 L15.6376812,9.63768275 L12.8260796,9.63769038 C12.5072393,9.63769038 12.2463686,9.73913981 12.0289769,9.95653067 C11.8115853,10.1594299 11.6956443,10.4492855 11.6956443,10.7536334 C11.710137,10.971025 11.7536154,11.1594299 11.8260791,11.3333444 C11.8985429,11.478272 11.9999922,11.6087076 12.1594117,11.7246486 C12.3188321,11.8405908 12.5362235,11.8985617 12.8260791,11.8985617 L15.652173,11.8985617 L15.652173,14.1594246 C15.652173,14.3043522 15.6231868,14.4637726 15.5652157,14.5942079 C15.5072446,14.7246427 15.4347809,14.8550767 15.3333317,14.9565273 C15.1304324,15.173919 14.8405769,15.28986 14.5507233,15.28986 L5.52173662,15.28986 C5.36231628,15.28986 5.21738871,15.2608745 5.07246095,15.2029034 C4.92753338,15.1449323 4.81159215,15.0579758 4.69564915,14.956527 C4.59419972,14.8550775 4.50724326,14.7391353 4.43478035,14.5942075 C4.37680925,14.44928 4.3478237,14.304352 4.3478237,14.1449319 L4.3478237,7.95652304 C4.3478237,7.63768275 4.46376571,7.37681199 4.68115638,7.15942034 C4.89854802,6.9420287 5.17391116,6.82608766 5.47825907,6.82608766 L14.5072458,6.82608766 Z M12.6521767,10.347835 C12.7971043,10.347835 12.9275398,10.4058062 13.0289885,10.4927626 C13.1304379,10.594212 13.1884088,10.739139 13.1884088,10.8695744 C13.1884088,11.014502 13.1304377,11.1449376 13.0289885,11.2463862 C12.9275391,11.3478356 12.7971045,11.4058065 12.6521767,11.4058065 C12.5072491,11.4058065 12.3768136,11.3478354 12.2753649,11.2463862 C12.1739155,11.1449368 12.1159446,11.0145022 12.1159446,10.8695744 C12.1159446,10.7246468 12.1739157,10.5942113 12.2753649,10.4927626 C12.3768143,10.3913132 12.5072489,10.3333423 12.6521767,10.347835 Z M12.3623214,4.69566383 C12.6086978,4.71015659 12.811597,4.73914216 12.9710172,4.81160585 C13.1594231,4.89856251 13.3333366,5.01450511 13.4782644,5.15943287 L14.2463803,6.46378078 L8.24636858,6.46378078 C8.71013664,6.24638914 9.15941232,6.02899749 9.59419561,5.82609823 C9.95652285,5.65218609 10.3333346,5.47827219 10.695654,5.30435966 C11.0579735,5.13044654 11.3333366,5.00001174 11.5362339,4.89856309 C11.8405818,4.75363553 12.115945,4.68117145 12.3623214,4.69566383 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.d2ca7e7382da46cdb5a79c193c55cde3.svg";
export { ForwardRef as ReactComponent };